import { render, staticRenderFns } from "./DepartmentsPage.vue?vue&type=template&id=248905b7"
import script from "./DepartmentsPage.vue?vue&type=script&lang=js"
export * from "./DepartmentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports